import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import { PAGE_SEO } from '../constants/seo';
import { breadcrumbSchema } from '../constants/structuredData';
import blogPosts from '../content/blogPosts.json';
import './Page.css';

const Blog = () => (
  <div className="page">
    <SeoHead
      {...PAGE_SEO.blog}
      jsonLd={breadcrumbSchema([
        { name: 'Home', path: '/' },
        { name: 'Blog', path: '/blog' },
      ])}
    />
    <section
      className="page-header blog-header"
      style={{ backgroundImage: 'url(/images/blog/deb746_b659eca4640e470d99ec52bab788346c~mv2.jpg)' }}
    >
      <div className="container">
        <h1>Untold Stories</h1>
        <p className="page-subtitle">Insights, tips, and health information from our team</p>
      </div>
    </section>

    <section className="page-content">
      <div className="container">
        <div className="content-section">
          <h2 className="section-title">Our Blog</h2>
          <p>
            Stay informed with our latest articles on healthcare, wellness, and medical insights.
            Our team of healthcare professionals shares valuable information to help you make
            informed decisions about your health.
          </p>
        </div>

        <div className="blog-posts-list">
          {blogPosts.map((post) => (
            <article key={post.slug} className="blog-post-full">
              <div className="blog-post-header">
                <Link to={`/blog/${post.slug}`} className="blog-post-image-full" aria-hidden="true" tabIndex={-1}>
                  <img src={post.image} alt={post.title} loading="lazy" />
                </Link>
                <div className="blog-post-header-content">
                  <div className="blog-post-meta">
                    <span className="blog-post-category">{post.category}</span>
                    <span className="blog-post-date">{post.datePublished.slice(0, 4)}</span>
                  </div>
                  <h2 className="blog-post-title-full">
                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  </h2>
                  <p className="blog-post-excerpt-full">{post.excerpt}</p>
                </div>
              </div>
              <Link to={`/blog/${post.slug}`} className="btn btn-primary" style={{ marginTop: '20px' }}>
                Read article
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default Blog;
